import React from "react";
import Plan from "./Plans";
import Male from "../../../assets/pricing/male.png";
import MessageBubble from "../../../components/utils/MessageBubble";
import Cta from "./Cta";
import styles from "./pricing.module.scss";
import { plans } from "../../../helpers/plans";

export default function Pricing() {
  return (
    <div className="mt-5">
      <div className="row align-items-center">
        <div className="col-12 col-md-6 p-2 m-1">
          <h2>
            Buy Headlockr 2FA with a <span style={{ color: "#00F6AC" }}>7-day</span> money-back guarantee.
          </h2>
          <p>
            Get every feature without limitations, deploy to production, and keep your users secure. If Headlockr is not the right fit, you can rely on the 7-day money-back guarantee.
          </p>
        </div>

        <div className="col mb-3 mb-md-0">
          <ul className="d-flex flex-wrap mb-0 list-style-none gap-2 text-white ps-0">
            <li className="d-flex align-items-center bg-secondary rounded-3" style={{ padding: "5px 10px" }}>
              <img
                src="https://img.icons8.com/?size=100&id=59850&format=png&color=00F6AC"
                alt="checkmark"
                className="me-1"
                style={{ width: 18, objectFit: "contain" }}
              />{" "}
              5-minute install
            </li>
            <li className="d-flex align-items-center bg-secondary rounded-3" style={{ padding: "5px 10px" }}>
              <img
                src="https://img.icons8.com/?size=100&id=59850&format=png&color=00F6AC"
                alt="checkmark"
                style={{ width: 18, objectFit: "contain" }}
                className="me-1"
              />{" "}
              Enterprise-grade security
            </li>
            <li className="d-flex align-items-center bg-secondary rounded-3" style={{ padding: "5px 10px" }}>
              <img
                src="https://img.icons8.com/?size=100&id=59850&format=png&color=00F6AC"
                alt="checkmark"
                style={{ width: 18, objectFit: "contain" }}
                className="me-1"
              />{" "}
              topt, passkeys, e-mail, sms & backup codes built-in
            </li>
            <li className="d-flex align-items-center bg-secondary rounded-3" style={{ padding: "5px 10px" }}>
              <img
                src="https://img.icons8.com/?size=100&id=59850&format=png&color=00F6AC"
                alt="checkmark"
                style={{ width: 18, objectFit: "contain" }}
                className="me-1"
              />{" "}
              Admin panel & Content-api ready
            </li>
            <li className="d-flex align-items-center bg-secondary rounded-3" style={{ padding: "5px 10px" }}>
              <img
                src="https://img.icons8.com/?size=100&id=59850&format=png&color=00F6AC"
                alt="checkmark"
                style={{ width: 18, objectFit: "contain" }}
                className="me-1"
              />{" "}
              No user cap or limits on your licence
            </li>
          </ul>
        </div>
      </div>

      <Plan plans={plans} />
      <div className="mt-8 position-relative">
        <img
          src={Male}
          alt="male"
          style={{
            width: "200px",
            height: "auto",
            position: "absolute",
            left: "55%",
            bottom: "40px",
            transform: "translate(-50%, 50%)",
          }}
        />
        <div
          style={{
            left: "44%",
            bottom: "-25px",
          }}
          className={`position-absolute translate-middle ${styles.bubble}`}
        >
          <MessageBubble message="7-day money back! 🤯" />
        </div>
      </div>
      <div className="my-20">
        <Cta />
      </div>
    </div>
  );
}
